export class User {
  /** Username of the logged in user.*/
  username: string;

  constructor(username: string) {
    this.username = username;
  }
}

export interface Jwt {
  data: JwtData;
  expired: boolean;
  valid: boolean;
}

export interface JwtData {
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  sub: string;
}
